import { Component, Input, OnInit } from '@angular/core';

export interface WizardStepItem {
	num: number;
	label: string;
	prop: string;
	isLast?: boolean; // is last step
	isFirst?: boolean; // is first step
	// UI
	isSameLine?: boolean;
}

@Component({
  selector: 'app-wizard-step-title',
  templateUrl: './wizard-step-title.component.html',
  styleUrls: ['./wizard-step-title.component.css']
})
export class WizardStepTitleComponent implements OnInit {

	@Input() stepLabel: string = '';
	@Input() stepNum: number;
	@Input() isCurrent: boolean;

	constructor() { }

	ngOnInit() {
	}

}
